import React, { useState } from 'react';
import Box from '../../../../components/Box';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetProductByIdResponseProductSubProduct } from '../../../../models/response/product/GetProductByIdResponse';
import { ProductService } from '../../../../services/ProductService';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { toast } from "react-hot-toast";
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { useDispatch } from 'react-redux';

interface Props {
    productSubProductsRef: any
    productSubProducts: GetProductByIdResponseProductSubProduct[]
    setProductSubProducts: React.Dispatch<React.SetStateAction<GetProductByIdResponseProductSubProduct[]>>
}

const SubProducts = ({
    productSubProductsRef,
    productSubProducts,
    setProductSubProducts
}: Props) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedSubProduct, setSelectedSubProduct] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [quantity, setQuantity] = useState<string | undefined>(undefined);
    const [productSubProductId, setProductSubProductId] = useState<string | undefined>(undefined);

    const saveItem = () => {
        if (Helpers.isEmpty(selectedSubProduct)) {
            toast.error('Ürün Adı alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(quantity)) {
            toast.error('Adet alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(productSubProductId)) {
            var o: GetProductByIdResponseProductSubProduct = {
                productSubProductId: Helpers.generateUUID(true),
                isSelected: false,
                quantity: Helpers.toNumber(quantity),
                subProductId: selectedSubProduct?.value,
                subProductName: selectedSubProduct?.label
            }

            setProductSubProducts([...productSubProducts, o])
        }
        else {
            setProductSubProducts(productSubProducts.map(function (x) {
                if (x.productSubProductId == productSubProductId) {
                    x.isSelected = false;
                    x.quantity = Helpers.toNumber(quantity);
                    x.subProductId = selectedSubProduct?.value;
                    x.subProductName = selectedSubProduct?.label;
                }

                return x;
            }))
        }

        setProductSubProductId('');
        setSelectedSubProduct(undefined);
        setQuantity('');
        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = productSubProducts.filter(x => x.isSelected)[0];
        setProductSubProductId(o.productSubProductId);
        setSelectedSubProduct(o.subProductId && o.subProductName ? { label: o.subProductName, value: o.subProductId } : undefined);
        setQuantity(o.quantity?.toString());
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setProductSubProductId('');
        setSelectedSubProduct(undefined);
        setQuantity('');
        setIsOpen(false);
        scrollTo();
    }

    const selectAll = () => {
        var isAllSelected = productSubProducts.length == productSubProducts.filter(x => x.isSelected).length;

        setProductSubProducts(productSubProducts.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setProductSubProducts(productSubProducts.filter(x => !x.isSelected));
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = productSubProductsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const setItemSelected = (_id: string) => {
        setProductSubProducts(productSubProducts.map(function (x) {
            if (x.productSubProductId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' ref={productSubProductsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Alt Ürünler</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Ürün Adı</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedSubProduct}
                                            onChange={setSelectedSubProduct}
                                            onMenuOpen={() => ProductService.getProductList(true)}
                                            labelName='name'
                                            valueName='productId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Adet</label>
                                        <CustomNumberInput value={quantity} setValue={setQuantity} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={productSubProducts.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={productSubProducts.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={productSubProducts.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={productSubProducts.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={productSubProducts.filter(x => x.isSelected).length > 0 && productSubProducts.filter(x => x.isSelected).length == productSubProducts.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Ürün Adı</th>
                                            <th>Adet</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            productSubProducts.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            productSubProducts.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.productSubProductId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.subProductName}</td>
                                                    <td>{item.quantity}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default SubProducts;